import Restful from '../utils/restful.js'
const project = 'sci/'

const database = new Restful(project, 'database')
export default database
